import { Component, OnInit } from '@angular/core';

@Component({templateUrl: 'install.component.html'})
export class InstallComponent {

    constructor() {
    }
}
